import React from 'react';
import Router from 'next/router';
import { GetServerSideProps, NextPage } from 'next';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIosOutlinedIcon from '@material-ui/icons/ArrowBackIosOutlined';
import styled from 'styled-components';
import { NextSeo } from 'next-seo';
import PostListings from '../components/PostListing';
import { authenticatedRoute } from '../utils/helpers';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const PostListingPage: NextPage = () => {
  const onBackHandler = () => {
    const confirm = window.confirm('Are you sure ?');
    if (confirm) Router.back();
  };
  return (
    <>
      <NextSeo
        canonical="https://rentable.pk/post-listing"
        title="Post listing on a rent"
        description="Rentable has rental ads available in Pakistan of goods from cars, furniture, electronics to every other rentable service listings. Rent Now!"
        openGraph={{
          url: 'https://rentable.pk/post-listing',
          title: 'Post listing on a rent',
          description:
            'Rentable has rental ads available in Pakistan of goods from cars, furniture, electronics to every other rentable service listings. Rent Now!',
          images: [
            {
              url: 'https://rentable.pk/assets/logos/green-text-logo.png',
              alt: 'Rentable Pakistan',
            },
          ],
        }}
      />
      <Container>
        <AppBar position="static" color="primary">
          <Toolbar>
            <IconButton edge="start" color="inherit" aria-label="menu" onClick={onBackHandler}>
              <ArrowBackIosOutlinedIcon />
            </IconButton>
            <Typography variant="h6">Back</Typography>
          </Toolbar>
        </AppBar>
        <PostListings />
      </Container>
    </>
  );
};
export const getServerSideProps: GetServerSideProps = async (ctx) => {
  authenticatedRoute(ctx);
  return { props: {} };
};
export default PostListingPage;
